import styled from 'styled-components'
import { colors } from '../../_styles/colors'
import { spacing } from '../../_styles/spacing'

export const StyledPageFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.white};
  padding: ${spacing.lg}px;
  width: 100%;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  bottom: 0;
`
